import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'
import { Trans } from 'react-i18next'
import { LtiFieldMappingHelpPage } from './LtiFieldMappingHelpPage'
import { stepComponents } from './stepComponents'

export const CanvasFieldMappingPage = observer(
  function CanvasFieldMappingPage() {
    const { tt } = useTranslationTyped()

    return (
      <LtiFieldMappingHelpPage
        content={tt.help.canvas}
        steps={
          <Trans
            i18nKey="help.canvas.update_steps"
            components={stepComponents}
          />
        }
      />
    )
  }
)
